import { FaIcon } from './icons/FaIcon';

export type PanelErrorWithIconProps = {
  title: string;
  description?: string;
  centerContent?: boolean;
};

export function PanelErrorWithIcon({ title, description, centerContent }: PanelErrorWithIconProps) {
  return (
    <div className="border border-danger rounded p-2">
      <div className={`d-flex align-items-center gap-3 ${centerContent ? 'justify-content-center' : ''}`}>
        <div className="flex-shrink-0">
          <FaIcon icon="fal fa-triangle-exclamation" size="xxl" cssClass="text-danger" />
        </div>
        <div className={centerContent ? 'text-start' : 'flex-grow-1'}>
          <div className="text-danger fw-medium">{title}</div>
          {description != null && description !== '' && (
            <div className="small text-danger">{description}</div>
          )}
        </div>
      </div>
    </div>
  );
}
